<template>
    <li v-if="workshopStatus" :class="status">
        <span>
            {{ workshopStatus.label }}
        </span>
    </li>
</template>
<script>
export default {
    name: "StatusListItem",
    props: {
        status: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
        workshopStatus: null,
        workshopStatusOptions: [{status: "requested", label: "Requested"}, 
                                {status: "approved", label: "Approved"},
                                {status: "rejected", label: "Rejected"},
                                {status: "canceled", label: "Canceled"}]
    }},
    async mounted() {
        this.workshopStatus = this.workshopStatusOptions.find(x => x.status === this.status);
    },
};
</script>
<style lang="scss">

.approved {
    font-weight: 500;
    background-color: $green !important;
    color: $dark-blue !important;
}
.started{
    font-weight: 500;
    color: $blue !important;
        animation-name: pulsing-a-color;
        animation-play-state: running;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-direction: alternate-reverse;
        animation-timing-function: ease;

    @keyframes pulsing-a-color {
        to {
            background-color: $green;
        }
    }
}

</style>